import { HttpClient } from '@angular/common/http';
import { environment } from '@env';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class TranslateHttpLoader implements TranslateLoader {
  public prefix: string;
  constructor(private http: HttpClient, public suffix: string = '.json') {
    const protocol = window.location.href.split('//')[0];
    const url = window.location.href.split('//')[1].split('/')[0];
    this.prefix = `${protocol}//${url}/assets/i18n/`;
  }

  public getTranslation(lang: string): Observable<unknown> {
    return this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(catchError((error) => of()));
  }
}

export const translateLoaderFactory = (http: HttpClient) => new TranslateHttpLoader(http);
